<!-- MODAL DE PERFIL DE USUARIO -->
<ng-template #miModal let-modal>
    <div class="modal-header" style="background-color: #f23064; color: white; text-align: center;">
        <h4 class="modal-title">{{ 'auth.intro' | t }}</h4>
    </div>
    <div class="modal-body" style="text-align: center;">
        <div id="logIn" *ngIf="logIn && !recoverPwd">
            <h3>{{ 'auth.login' | t }}</h3>
            <form [formGroup]="myFormLogin" novalidate>
                <div class="input-group mb-3">
                    <input type="email" formControlName="Email" class="form-control" [placeholder]="'auth.emailPlaceholder' | t">

                </div>
                <!-- VALIDACIONES CORREO -->
                <div class="mb-3" *ngIf="myFormLogin.get('Email').errors && myFormLogin.get('Email').dirty">
                    <span class="spanAlert" *ngIf="myFormLogin.get('Email').hasError('required')">
                        {{ 'validation.required' | t }}
                    </span>
                    <span class="spanAlert" *ngIf="myFormLogin.get('Email').hasError('invalidEmail')">
                        {{ 'validation.invalidFormat' | t }}
                    </span>
                </div>
                <!-- VALIDACIONES CORREO -->

                <div class="input-group mb-3">
                    <input type="password" class="form-control" [placeholder]="'auth.passwordPlaceholder' | t"
                        formControlName="Password">
                </div>
                <!-- VALIDACIONES CONTRASEÑA -->
                <div class="mb-3" *ngIf="myFormLogin.get('Password').errors && myFormLogin.get('Password').dirty">
                    <span class="spanAlert" *ngIf="myFormLogin.get('Password').hasError('required')">
                        {{ 'validation.required' | t }}
                    </span>
                    <span class="spanAlert" *ngIf="myFormLogin.get('Password').errors">
                        {{ 'validation.passwordLength' | t }}
                    </span>
                </div>
                <!-- VALIDACIONES CONTRASEÑA -->
                <p style="font-weight: bold; cursor: pointer;" (click)="logInRegister(false, 1)">{{ 'auth.noAccount' | t }}</p>
                <p style="font-weight: bold; cursor: pointer;" (click)="logInRegister(false, 2)">{{ 'auth.recover' | t }}
                </p>
            </form>
        </div>
        <div id="register" *ngIf="!logIn && !recoverPwd">
            <h3>{{ 'auth.registerHere' | t }}</h3>
            <form [formGroup]="myFormRegister" novalidate>
                <div class="input-group mb-3">
                    <input formControlName="Name" type="text" class="form-control" [placeholder]="'auth.namePlaceholder' | t">

                </div>
                <!-- VALIDACIONES NOMBRE -->
                <div class="mb-3" *ngIf="myFormRegister.get('Name').errors && myFormRegister.get('Name').dirty">
                    <span class="spanAlert" *ngIf="myFormRegister.get('Name').hasError('required')">
                        {{ 'validation.required' | t }}
                    </span>
                    <span class="spanAlert" *ngIf="myFormRegister.get('Name').errors">
                        {{ 'validation.nameLength' | t }}
                    </span>
                </div>
                <!-- VALIDACIONES NOMBRE -->

                <div class="input-group mb-3">
                    <input type="email" formControlName="Email" class="form-control" [placeholder]="'auth.emailPlaceholder' | t">

                </div>
                <!-- VALIDACIONES CORREO -->
                <div class="mb-3" *ngIf="myFormRegister.get('Email').errors && myFormRegister.get('Email').dirty">
                    <span class="spanAlert" *ngIf="myFormRegister.get('Email').hasError('required')">
                        {{ 'validation.required' | t }}
                    </span>
                    <span class="spanAlert" *ngIf="myFormRegister.get('Email').hasError('invalidEmail')">
                        {{ 'validation.invalidFormat' | t }}
                    </span>
                </div>
                <!-- VALIDACIONES CORREO -->

                <div class="input-group mb-3">
                    <input type="number" class="form-control" [placeholder]="'auth.phonePlaceholder' | t"
                        formControlName="PhoneNumber">
                </div>
                <!-- VALIDACIONES TELEFONO -->
                <div class="mb-3"
                    *ngIf="myFormRegister.get('PhoneNumber').errors && myFormRegister.get('PhoneNumber').dirty">
                    <span class="spanAlert" *ngIf="myFormRegister.get('PhoneNumber').hasError('required')">
                        {{ 'validation.required' | t }}
                    </span>
                    <span class="spanAlert" *ngIf="myFormRegister.get('PhoneNumber').errors">
                        {{ 'validation.phoneLength' | t }}
                    </span>
                </div>
                <!-- VALIDACIONES TELEFONO -->

                <div class="input-group mb-3">
                    <input type="password" class="form-control" [placeholder]="'auth.passwordPlaceholder' | t"
                        formControlName="Password">
                </div>
                <!-- VALIDACIONES CONTRASEÑA -->
                <div class="mb-3" *ngIf="myFormRegister.get('Password').errors && myFormRegister.get('Password').dirty">
                    <span class="spanAlert" *ngIf="myFormRegister.get('Password').hasError('required')">
                        {{ 'validation.required' | t }}
                    </span>
                    <span class="spanAlert" *ngIf="myFormRegister.get('Password').errors">
                        {{ 'validation.passwordLength' | t }}
                    </span>
                </div>
                <!-- VALIDACIONES CONTRASEÑA -->
                <p style="font-weight: bold; cursor: pointer;" (click)="logInRegister(true, 1)">{{ 'auth.hasAccount' | t }}</p>
            </form>

        </div>
        <div id="recover" *ngIf="recoverPwd">
            <h3>{{ 'auth.recoverTitle' | t }}</h3>
            <h4>{{ 'auth.recoverHelp' | t }}</h4>

            <form [formGroup]="forgotPwdForm" novalidate>

                <!-- EMAIL -->
                <div class="input-group mb-3">
                    <input type="email" formControlName="email" class="form-control" [placeholder]="'auth.emailPlaceholder' | t">
                </div>
                <div class="mb-3" *ngIf="forgotPwdForm.get('email')?.invalid && forgotPwdForm.get('email')?.touched">
                    <span class="spanAlert" *ngIf="forgotPwdForm.get('email')?.hasError('required')">
                        {{ 'validation.required' | t }}
                    </span>
                    <span class="spanAlert" *ngIf="forgotPwdForm.get('email')?.hasError('pattern')">
                        {{ 'validation.invalidFormat' | t }}
                    </span>
                </div>

                <!-- CONTRASEÑA ANTERIOR -->
                <div class="input-group mb-3">
                    <input type="password" formControlName="oldPwd" class="form-control"
                        [placeholder]="'auth.newPasswordPlaceholder' | t">
                </div>
                <div class="mb-3" *ngIf="forgotPwdForm.get('oldPwd')?.invalid && forgotPwdForm.get('oldPwd')?.touched">
                    <span class="spanAlert" *ngIf="forgotPwdForm.get('oldPwd')?.hasError('required')">
                        {{ 'validation.required' | t }}
                    </span>
                    <span class="spanAlert" *ngIf="forgotPwdForm.get('oldPwd')?.hasError('minlength')">
                        {{ 'validation.minimumFive' | t }}
                    </span>
                </div>

                <!-- NUEVA CONTRASEÑA -->
                <div class="input-group mb-3">
                    <input type="password" formControlName="newPwd" class="form-control"
                        [placeholder]="'auth.repeatPasswordPlaceholder' | t">
                </div>
                <div class="mb-3" *ngIf="forgotPwdForm.get('newPwd')?.invalid && forgotPwdForm.get('newPwd')?.touched">
                    <span class="spanAlert" *ngIf="forgotPwdForm.get('newPwd')?.hasError('required')">
                        {{ 'validation.required' | t }}
                    </span>
                    <span class="spanAlert" *ngIf="forgotPwdForm.get('newPwd')?.hasError('minlength')">
                        {{ 'validation.minimumFive' | t }}
                    </span>
                </div>

                <!-- VALIDACIÓN CONTRASEÑAS IGUALES -->
                <div class="mb-3"
                    *ngIf="forgotPwdForm.errors?.passwordMismatch && forgotPwdForm.get('newPwd')?.touched">
                    <span class="spanAlert">
                        {{ 'validation.passwordMismatch' | t }}
                    </span>
                </div>

                <p style="font-weight: bold; cursor: pointer;" (click)="logInRegister(false, 1)">
                    {{ 'auth.noAccount' | t }}
                </p>
            </form>
        </div>

    </div>
    <div class="modal-footer">
        <button class="btn btn-danger" (click)="closeModal()">{{ 'auth.noThanks' | t }}</button>
        <button class="btn btn-primary" (click)="loginUser()" *ngIf="logIn && !recoverPwd"
            [disabled]="myFormLogin.invalid">{{ 'auth.login' | t }}</button>
        <button class="btn btn-primary" (click)="createUser()" *ngIf="!logIn && !recoverPwd"
            [disabled]="myFormRegister.invalid">{{ 'auth.register' | t }}</button>
        <button class="btn btn-primary" (click)="recoveryPwd()" *ngIf="recoverPwd"
            [disabled]="forgotPwdForm.invalid">{{ 'auth.recover' | t }}</button>
    </div>
</ng-template>

<!-- MODAL DE VERIFICACION -->
<ng-template #modalCode let-c="close" let-d="dismiss">
    <div class="modal-body">

        <h2 class="titleModal">{{ 'auth.otpPrompt' | t }}</h2>
        <form class="form-horizontal text-center">
            <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{length:6}"></ng-otp-input>
        </form>
        <br>
        <br>
        <div class=" text-center">

            <button class="btn btn-success w-md btn-rounded" type="button" style="margin-left: 5px;"
                (click)="verifyCode();" [disabled]="loading">
                <i class="bx bx-check"></i>
                {{ 'auth.verifyCode' | t }}
            </button>
        </div>
    </div>
</ng-template>

<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
